import { useCallback } from 'react';
import { hideAppSpinner, showAppMessage, showAppSpinner } from '@rainbow-modules/app';
import useHttpMutation from 'data/firestore/useHttpMutation';
import FormFooter from './footer';
import Form from './form';
import { Container, Content } from './styled';
import { BaseFormProps } from './types';

interface CreateFormProps extends BaseFormProps {}

const CreatePhoneNumberForm = ({
    agentId = '',
    onRequestClose = () => {},
    onCompleted = () => {},
}: CreateFormProps) => {
    const {
        mutateAsync: createPhoneNumber,
    } = useHttpMutation<Record<string, unknown>, Record<string, unknown>>({
        pathname: `/agents/${agentId}/phone-numbers`,
        method: 'POST',
        onSuccess: (response) => {
            onRequestClose();
            onCompleted(response);
        },
    });

    const handleSubmit = useCallback(
        async (values: Record<string, unknown>) => {
            try {
                showAppSpinner();
                await createPhoneNumber({
                    body: values,
                });
            } catch (error) {
                showAppMessage({
                    variant: 'error',
                    message: (error as Error).message,
                    timeout: 5000,
                });
            }
            hideAppSpinner();
        },
        [createPhoneNumber],
    );

    return (
        <Container>
            <Content>
                <Form
                    id="phone-number-form"
                    agentId={agentId}
                    onSubmit={handleSubmit}
                />
            </Content>
            <FormFooter
                formId="phone-number-form"
                onCancelClick={onRequestClose}
            />
        </Container>
    );
};

export default CreatePhoneNumberForm;
